import { SheetEvent } from "../events/sheet_event.js";
import { Deferred } from "../utilities/deferred.js";
import { createElement, getElement } from "../utilities/elements";
import { Service } from "./Service.js";

export class SheetService extends Service {
  /** @type {HTMLElement|null} Ref to the current sheet */
  #sheet = null;
  /** @type {Deferred<void>|null} Deferred to resolve on close */
  #closed = null;

  /**
   * @param {HTMLElement} owner
   * @param {string | Node} content
   * @returns {Promise<void>} promise that resolves when the sheet is closed
   */
  open(owner, content) {
    if (this.#closed !== null) {
      throw new Error("Sheet is already open");
    }
    const body = getElement(document, "body");
    body.style.overflow = "hidden";
    this.#sheet = createElement(`<dt-sheet></dt-sheet>`);
    this.#sheet.append(content);
    // Allow the sheet to close itself by notifying the service, for example if
    // the user clicks on the backdrop or swipes it away
    this.#sheet.addEventListener(SheetEvent.CLOSE, () => this.close(), {
      once: true,
    });
    // Append the sheet as a child of the owner so that events bubble to the
    // owner for handling
    owner.append(this.#sheet);
    this.#closed = new Deferred();
    return this.#closed;
  }

  /**
   * @returns {Promise<void>} promise that resolves when the sheet is closed
   */
  async close() {
    if (this.#closed === null) {
      return;
    }
    const sheet = await this.#sheet.animateClose();
    sheet.remove();
    this.#sheet = null;
    const body = getElement(document, "body");
    body.style.overflow = "";
    this.#closed.resolve();
    this.#closed = null;
  }
}
